import { render, staticRenderFns } from "./payment-pending-mobile.vue?vue&type=template&id=51d3cd78&scoped=true"
import script from "./payment-pending-mobile.vue?vue&type=script&lang=js"
export * from "./payment-pending-mobile.vue?vue&type=script&lang=js"
import style0 from "./payment-pending-mobile.vue?vue&type=style&index=0&id=51d3cd78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3cd78",
  null
  
)

export default component.exports